import React from 'react';
import { Container, Row } from 'reactstrap';
import config from 'config';

const Index: React.FC = () => {
  return (
    <>
      <div className={`header bg-gradient-${config.class} pb-8 pt-5 pt-7`}>
        <Container fluid>
          <div className="header-body">
            <Row>
              <div
                style={{
                  display: 'flex',
                  float: 'left',
                  fontFamily: 'Open Sans',
                  fontSize: '50px',
                  color: '#fff',
                  alignItems: 'botom',
                  marginTop: '40px',
                  marginLeft: '40px',
                }}
              >
                <div
                  style={{
                    width: '100%',
                    fontSize: '50px',
                    color: '#fff',
                  }}
                >
                  Bem vindo!
                </div>
              </div>
            </Row>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Index;
